import Main from '@/views/Main.vue'
export const loginRouter = {
    path: '/login',
    name: 'login',
    meta: {
        title: 'Login - 登录',
        requireAuth: true
    },
    component: () =>
    import('@/views/login.vue'),
    alias: '/'
}
export const loginJump = {
    path: '/loginJump',
    meta: {
        title: '登录跳转'
    },
    name: 'loginJump',
    component: () =>
    import('@/views/errorpage/loginJump.vue')
}
export const page403 = {
    path: '/403',
    meta: {
        title: '403-权限不足',
        requireAuth: true
    },
    name: 'error-403',
    component: () =>
    import('@/views/errorpage/403.vue')
}

export const page404 = {
    path: '/404',
    meta: {
        title: '404-页面不存在或已被删除'
    },
    name: 'error-404',
    component: () =>
    import('@/views/errorpage/404.vue')
}
export const page500 = {
    path: '/500',
    meta: {
        title: '500-服务端错误'
    },
    name: 'error-500',
    component: () =>
    import('@/views/errorpage/500.vue')
}
// 作为Main组件的子页面展示并且在菜单显示的路由写在appRouter里
export const appRouter = [{
                              path: '/home',
                              name: 'home',
                              title: '首页',
                              component: Main,
                              children: [{
                                  path: 'index',
                                  title: '首页',
                                  name: 'index',
                                  meta: {
                                      requireAuth: true
                                  },
                                  icon: 'compose',
                                  component: () => import('@/views/home/index.vue')
                              }]
                          },
                          {
                              path: '/system',
                              name: 'system',
                              title: '用户管理',
                              component: Main,
                              children: [
                                  // 权限管理
                                  {
                                      path: 'departmentList',
                                      title: '部门管理',
                                      name: 'departmentList',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/department/departmentList.vue')
                                  }, {
                                      path: 'userlist',
                                      title: '人员列表',
                                      name: 'userlist',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/employee/userlist.vue')
                                  },
                                  // 权限管理
                                  {
                                      path: 'roleList',
                                      title: '角色管理',
                                      name: 'roleList',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/permissions/roleList.vue')
                                  },
                                  {
                                      path: 'approvalTree',
                                      title: '审批节点管理',
                                      name: 'approvalTree',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/permissions/approvalTree.vue')
                                  },
                                  {
                                      path: 'receiverInStationHistory',
                                      title: '终端挂岗历史',
                                      name: 'receiverInStationHistory',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/permissions/receiverInStationHistory.vue')
                                  },
                                  {
                                      path: 'employeeInStationHistory',
                                      title: '人员上岗历史',
                                      name: 'employeeInStationHistory',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/permissions/employeeInStationHistory.vue')
                                  },
                                  {
                                      path: 'provinceInStationHistory',
                                      title: '省份关联岗位历史',
                                      name: 'provinceInStationHistory',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/permissions/provinceInStationHistory.vue')
                                  },
                                  // 字典管理
                                  {
                                      path: 'dictionaryAdministration',
                                      title: '字典管理',
                                      name: 'dictionaryAdministration',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/dictionaries/dictionaryAdministration.vue')
                                  },
                                  {
                                      path: 'replyRadixSetting',
                                      title: '反馈基数设置',
                                      name: 'replyRadixSetting',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/saleFlowSetting/replyRadixSetting.vue')
                                  },
                                  {
                                      path: 'replyRateLineSetting',
                                      title: '退货率基线设置',
                                      name: 'replyRateLineSetting',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/saleFlowSetting/replyRateLineSetting.vue')
                                  },
                                  // 流向设置
                                  {
                                      path: 'productSettingOfSuspect',
                                      title: '疑似调拨品种设置',
                                      name: 'productSettingOfSuspect',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/saleFlowSetting/productSettingOfSuspect.vue')
                                  },
                                  // 周期管理
                                  {
                                      path: 'cycleManagement',
                                      title: '周期管理',
                                      name: 'cycleManagement',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/cycleManagement/cycleManagement.vue')
                                  },
                                  // 自动服务运行状态查询
                                  {
                                      path: 'taskStatus',
                                      title: '自动服务运行状态查询',
                                      name: 'taskStatus',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/cycleManagement/taskStatus.vue')
                                  },
                                  // 进销存设置
                                  {
                                      path: 'inventoryReportSetup',
                                      title: '库存报表设置',
                                      name: 'inventoryReportSetup',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/inventorySetting/inventoryReportSetup.vue')
                                  },
                                  {
                                      path: 'baselineOfInventoryCheckDate',
                                      title: '日库存差异反馈基线',
                                      name: 'baselineOfInventoryCheckDate',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/inventorySetting/baselineOfInventoryCheckDate.vue')
                                  },
                                  {
                                      path: 'discrepancyRateOfInventoryDaily',
                                      title: '日库存差异率设置',
                                      name: 'discrepancyRateOfInventoryDaily',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/inventorySetting/discrepancyRateOfInventoryDaily.vue')
                                  },
                                  {
                                      path: 'exceptionLogQuery',
                                      title: '异常日志管理',
                                      name: 'exceptionLogQuery',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/logManagement/exceptionLogQuery.vue')
                                  },
                                  {
                                      path: 'eventLogQuery',
                                      title: '事件日志管理',
                                      name: 'eventLogQuery',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/logManagement/eventLogQuery.vue')
                                  },
                                  {
                                      path: 'documentList',
                                      title: '常用文档设置',
                                      name: 'documentList',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/download/documentList.vue')
                                  },
                                  {
                                      path: 'loginLogQuery',
                                      title: '登录日志管理',
                                      name: 'loginLogQuery',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/logManagement/loginLogQuery.vue')
                                  },
                                  {
                                      path: 'sfelogquery',
                                      title: 'SFE日志管理',
                                      name: 'sfelogquery',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/logManagement/sfeLogQuery.vue')
                                  },
                                  {
                                      path: 'announcementQuery',
                                      title: '公告维护',
                                      name: 'announcementQuery',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/user/announcementQuery.vue')
                                  },
                                  // 首页设置
                                  {
                                      path: 'noticeDefaultNumberSetting',
                                      title: '公告默认条数设置',
                                      name: 'noticeDefaultNumberSetting',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/homeSettings/noticeDefaultNumberSetting.vue')
                                  }
                              ]
                          },
                          {
                              path: '/master',
                              name: 'master',
                              title: '产品主数据',
                              component: Main,
                              children: [{
                                             path: 'product',
                                             title: '产品基本信息',
                                             name: 'product',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/product/product.vue')
                                         },
                                         {
                                             path: 'productlevel',
                                             title: '产品组管理',
                                             name: 'productlevel',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/product/productlevel.vue')
                                         },
                                         {
                                             path: 'accountingprice',
                                             title: '价格管理',
                                             name: 'accountingprice',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/accountingPrice/accountingPriceList.vue')
                                         },
                                         {
                                             path: 'batchimport',
                                             title: '批号导入',
                                             name: 'batchimport',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/product/batchimport.vue')
                                         },
                                         {
                                             path: 'batchlist',
                                             title: '产品批号',
                                             name: 'batchlist',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/product/batchlist.vue')
                                         },
                                         {
                                             path: 'batchanother',
                                             title: '批号别名',
                                             name: 'batchanother',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/product/batchanother.vue')
                                         },
                                         {
                                             path: 'allmateriallist',
                                             title: '全部物料',
                                             name: 'allmateriallist',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/product/allmateriallist.vue')
                                         },
                                         // 流向商业管理
                                         {
                                             path: 'distributorList',
                                             title: '流向商业管理',
                                             name: 'distributorList',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/distributorList/distributorList.vue')
                                         },
                                         {
                                             path: 'myApproval',
                                             title: '审批记录',
                                             name: 'myApproval',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/distributorList/myApproval.vue')
                                         },
                                         {
                                             path: 'applyList',
                                             title: '我的申请',
                                             name: 'applyList',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/distributorList/applyList.vue')
                                         },
                                         {
                                             path: 'confirmList',
                                             title: '我的待办',
                                             name: 'confirmList',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/distributorList/confirmList.vue')
                                         },
                                         {
                                             path: 'contractorList',
                                             title: '联系人管理',
                                             name: 'contractorList',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/distributorList/contractorList.vue')
                                         },
                                         {
                                             path: 'productChannelList',
                                             title: '渠道管理',
                                             name: 'productChannelList',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/distributorList/productChannelList.vue')
                                         },
                                         {
                                             path: 'historyBillQuery',
                                             title: '历史单据查询',
                                             name: 'historyBillQuery',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/distributorList/historyBillQuery.vue')
                                         },
                                         // 收货方
                                         {
                                             path: 'receiverList',
                                             title: '收货方管理',
                                             name: 'receiverList',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/receiver/receiverList.vue')
                                         },
                                         {
                                             path: 'receiverAliasList',
                                             title: '收货方别名管理',
                                             name: 'receiverAliasList',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/receiver/receiverAliasList.vue')
                                         },
                                         {
                                             path: 'receiverLog',
                                             title: '收货方日志',
                                             name: 'receiverLog',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/receiver/receiverLog.vue')
                                         },
                                         // 地理信息管理
                                         {
                                             path: 'areaList',
                                             title: '大区管理',
                                             name: 'areaList',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/geography/areaList.vue')
                                         },
                                         {
                                             path: 'cityList',
                                             title: '城市管理',
                                             name: 'cityList',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/geography/cityList.vue')
                                         },
                                         {
                                             path: 'countyList',
                                             title: '区县管理',
                                             name: 'countyList',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/geography/countyList.vue')
                                         },
                                         {
                                             path: 'targetReceiver',
                                             title: '目标客户管理',
                                             name: 'targetReceiver',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/targetReceiver/targetReceiverList.vue')
                                         },
                                         {
                                             path: 'doctor',
                                             title: '医生&讲者查询',
                                             name: 'doctor',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/doctor/doctorList.vue')
                                         },
                                         {
                                             path: 'departmentProject',
                                             title: '部门项目管理',
                                             name: 'departmentProject',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/departmentProject/departmentProject.vue')
                                         },
                                         {
                                             path: 'receiverLevel',
                                             title: '客户分级管理',
                                             name: 'receiverLevel',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/receiverLevel/receiverLevelList.vue')
                                         },
                                         {
                                             path: 'hospitalProcurement',
                                             title: '医院进药管理',
                                             name: 'hospitalProcurement',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/hospitalProcurement/hospitalProcurement.vue')
                                         },
                                         {
                                             path: 'drugstoreOfHospital',
                                             title: '院外药店管理',
                                             name: 'drugstoreOfHospital',
                                             meta: {
                                                 requireAuth: true
                                             },
                                             icon: 'compose',
                                             component: () => import('@/views/master/drugstoreOfHospital/drugstoreOfHospital.vue')
                                         }

                              ]
                          }, {
                              path: '/salesFlow',
                              name: 'salesFlow',
                              title: '流向管理',
                              component: Main,
                              children: [
                                  // 数据导入
                                  {
                                      path: 'DDIImport',
                                      title: 'DDI数据导入',
                                      name: 'DDIImport',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/dataImport/DDIImport.vue')
                                  },
                                  {
                                      path: 'monthlySAPData',
                                      title: 'SAP月数据生成',
                                      name: 'monthlySAPData',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/dataImport/monthlySAPData.vue')
                                  },
                                  {
                                      path: 'manualUploadLog',
                                      title: '上传日志列表',
                                      name: 'manualUploadLog',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/dataImport/manualUploadLog.vue')
                                  },
                                  {
                                      path: 'autoUploadLog',
                                      title: '自动日志列表',
                                      name: 'autoUploadLog',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/dataImport/autoUploadLog.vue')
                                  },
                                  // 流向数据确认
                                  {
                                      path: 'distributorSalesFlowConfirm',
                                      title: '流向商业流向确认',
                                      name: 'distributorSalesFlowConfirm',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/salesFlowConfirm/distributorSalesFlowConfirm.vue')
                                  },
                                  {
                                      path: 'salesFlowComplaintsQuery',
                                      title: '流向申诉审核',
                                      name: 'salesFlowComplaintsQuery',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/salesFlowConfirm/salesFlowComplaintsQuery.vue')
                                  },
                                  // 采购数据查询
                                  {
                                      path: 'monthlyPurchaseQuery',
                                      title: '月采购数据',
                                      name: 'monthlyPurchaseQuery',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/otherQuery/monthlyPurchaseQuery.vue')
                                  },
                                  {
                                      path: 'dailyPurchaseQuery',
                                      title: '日采购数据',
                                      name: 'dailyPurchaseQuery',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/otherQuery/dailyPurchaseQuery.vue')
                                  },
                                  // 月流向数据查询
                                  {
                                      path: 'monthlySalesFlowQuery',
                                      title: '月流向查询',
                                      name: 'monthlySalesFlowQuery',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/salesFlowQuery/monthlySalesFlowQuery.vue')
                                  },
                                  {
                                      path: 'distributorDailyStatusQuery',
                                      title: '流向商业日提供情况',
                                      name: 'distributorDailyStatusQuery',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/otherQuery/distributorDailyStatusQuery.vue')
                                  },
                                  {
                                      path: 'distributorMonthStatusQuery',
                                      title: '流向商业月提供情况',
                                      name: 'distributorMonthStatusQuery',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/otherQuery/distributorMonthStatusQuery.vue')
                                  },
                                  {
                                      path: 'dailySalesFlowQuery',
                                      title: '日流向查询',
                                      name: 'dailySalesFlowQuery',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/salesFlowQuery/dailySalesFlowQuery.vue')
                                  },
                                  {
                                      path: 'salesDailySalesFlowQuery',
                                      title: '销售日流向查询',
                                      name: 'salesDailySalesFlowQuery',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/salesFlowQuery/salesDailySalesFlowQuery.vue')
                                  },
                                  {
                                      path: 'salesMonthlySalesFlowQuery',
                                      title: '销售月流向查询',
                                      name: 'salesMonthlySalesFlowQuery',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/salesFlowQuery/salesMonthlySalesFlowQuery.vue')
                                  },
                                  {
                                      path: 'channelAbnormalFeedBack',
                                      title: '渠道异常反馈',
                                      name: 'channelAbnormalFeedBack',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/salesFlowInspect/channelAbnormalInspect.vue')
                                  },
                                  {
                                      path: 'suspectAllocation',
                                      title: '疑似调拨',
                                      name: 'suspectAllocation',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/salesFlowInspect/suspectAllocation.vue')
                                  },
                                  // 数据删除
                                  {
                                      path: 'deleteDailyStatus',
                                      title: '删除日数据提供情况',
                                      name: 'deleteDailyStatus',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/deleteData/deleteDailyStatus.vue')
                                  },
                                  {
                                      path: 'deleteMonthlyPurchase',
                                      title: '删除月采购数据',
                                      name: 'deleteMonthlyPurchase',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/deleteData/deleteMonthlyPurchase.vue')
                                  },
                                  {
                                      path: 'deleteDailyPurchase',
                                      title: '删除日采购数据',
                                      name: 'deleteDailyPurchase',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/deleteData/deleteDailyPurchase.vue')
                                  },
                                  {
                                      path: 'deleteDailyStock',
                                      title: '删除日库存',
                                      name: 'deleteDailyStock',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/deleteData/deleteDailyStock.vue')
                                  },
                                  {
                                      path: 'deleteMonthlyStock',
                                      title: '删除月库存',
                                      name: 'deleteMonthlyStock',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/deleteData/deleteMonthlyStock.vue')
                                  },
                                  {
                                      path: 'deleteDailySalesFlow',
                                      title: '删除日流向',
                                      name: 'deleteDailySalesFlow',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/deleteData/deleteDailySalesFlow.vue')
                                  },
                                  {
                                      path: 'salesReturnOwner',
                                      title: '销退主导人',
                                      name: 'salesReturnOwner',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/salesReturn/salesReturnOwner.vue')
                                  },
                                  {
                                      path: 'salesReturnReason',
                                      title: '销退原因',
                                      name: 'salesReturnReason',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/salesReturn/salesReturnReason.vue')
                                  },
                                  {
                                      path: 'salesReturnReply',
                                      title: '销退反馈',
                                      name: 'salesReturnReply',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/salesFlow/salesReturn/salesReturnReply.vue')
                                  }
                              ]
                          },
                          {
                              path: '/inventory',
                              name: 'inventory',
                              title: '库存管理',
                              component: Main,
                              children: [
                                  // 进销存报告
                                  {
                                      path: 'inventoryList',
                                      title: '库存管理',
                                      name: 'inventoryList',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/inventory/inventoryManagement/inventoryList.vue')
                                  },
                                  {
                                      path: 'inventoryGenerate',
                                      title: '计算报告',
                                      name: 'inventoryGenerate',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/inventory/inventoryManagement/inventoryGenerate.vue')
                                  },
                                  {
                                      path: 'inventoryBatchNumberReport',
                                      title: '批号库存报告',
                                      name: 'inventoryBatchNumberReport',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/inventory/inventoryManagement/inventoryBatchNumberReport.vue')
                                  },
                                  // 库存天数计算
                                  {
                                      path: 'distributorInventoryDay',
                                      title: '流向商业库存天数',
                                      name: 'distributorInventoryDay',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/inventory/inventoryDaysCalculation/distributorInventoryDay.vue')
                                  },
                                  {
                                      path: 'dailyInventoryFeedBack',
                                      title: '日库存差异反馈',
                                      name: 'dailyInventoryFeedBack',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/inventory/inventoryInspect/dailyInventoryInspect.vue')
                                  },
                                  // 进销存报表
                                  {
                                      path: 'otherItemReport',
                                      title: '进销存其它项汇总',
                                      name: 'otherItemReport',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/inventory/inventoryReport/otherItemReport.vue')
                                  },
                                  {
                                      path: 'distributorProductReport',
                                      title: '按产品经销商统计',
                                      name: 'distributorProductReport',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/inventory/inventoryReport/distributorProductReport.vue')
                                  },
                                  {
                                      path: 'negativeStockFeedBack',
                                      title: '负库存反馈',
                                      name: 'negativeStockFeedBack',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/inventory/inventoryReport/flowNegativeStock.vue')
                                  },
                                  {
                                      path: 'inventoryUpdateReport',
                                      title: '库存更新报告',
                                      name: 'inventoryUpdateReport',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/inventory/inventoryReport/inventoryUpdateReport.vue')
                                  },
                                  // 日库存
                                  {
                                      path: 'dailyInventoryList',
                                      title: '日库存查询',
                                      name: 'dailyInventoryList',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/inventory/dailyInventory/dailyInventoryList.vue')
                                  },
                                  {
                                      path: 'inventoryEstimateMonth',
                                      title: '当月库存预估',
                                      name: 'inventoryEstimateMonth',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () =>
                                    import('@/views/inventory/inventoryDaysCalculation/inventoryEstimateMonth.vue')
                                  },
                                  {
                                      path: 'safetyStockRange',
                                      title: '安全库存范围设置',
                                      name: 'safetyStockRange',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/system/inventorySetting/safetyStockRange.vue')
                                  }
                              ]
                          },
                          {
                              path: '/sales',
                              name: 'sales',
                              title: '销售管理',
                              component: Main,
                              children: [
                                  {
                                      path: 'quota',
                                      title: '阶段潜力管理',
                                      name: 'quota',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/sales/quota/quotaMasterList.vue')
                                  },
                                  {
                                      path: 'areaQuota',
                                      title: '岗位潜力查询',
                                      name: 'areaQuota',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/sales/quota/areaQuotaList.vue')
                                  },
                                  {
                                      path: 'receiverQuota',
                                      title: '终端潜力管理',
                                      name: 'receiverQuota',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/sales/quota/receiverQuotaList.vue')
                                  },
                                  {
                                      path: 'employeeQuota',
                                      title: '人员潜力管理',
                                      name: 'employeeQuota',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/sales/quota/employeeQuotaList.vue')
                                  }
                              ]
                          },
                          {
                              path: '/dataReport',
                              name: 'dataReport',
                              title: '数据报表',
                              component: Main,
                              children: [
                                  {
                                      path: 'salesAchievementReport',
                                      title: '人员销售达成率',
                                      name: 'salesAchievementReport',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/dataReport/salesReport/salesAchievementReport.vue')
                                  },
                                  {
                                      path: 'receiverSalesAchievementReport',
                                      title: '终端销售达成率',
                                      name: 'receiverSalesAchievementReport',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/dataReport/salesReport/receiverSalesAchievementReport.vue')
                                  },
                                  {
                                      path: 'targetHospitalQoQReport',
                                      title: '重点目标医院环比贡献',
                                      name: 'targetHospitalQoQReport',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/dataReport/salesReport/targetHospitalQoQReport.vue')
                                  },
                                  {
                                      path: 'salesAmountRankReport',
                                      title: '销售额排名',
                                      name: 'salesAmountRankReport',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/dataReport/rankReport/salesAmountRankReport.vue')
                                  },
                                  {
                                      path: 'hospitalDevelop',
                                      title: '医院开发',
                                      name: 'hospitalDevelop',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/dataReport/hospitalDevelop/hospitalDevelop.vue')
                                  },
                                  {
                                      path: 'receiverSalesWarning',
                                      title: '销量预警报表',
                                      name: 'receiverSalesWarning',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/dataReport/warningReport/receiverSalesWarning.vue')
                                  },
                                  {
                                      path: 'hospitalProcurementWarning',
                                      title: '进药预警报表',
                                      name: 'hospitalProcurementWarning',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/dataReport/warningReport/hospitalProcurementWarning.vue')
                                  },
                                  {
                                      path: 'salesAmountABSRankReport',
                                      title: '产品销售额绝对值排名',
                                      name: 'salesAmountABSRankReport',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/dataReport/rankReport/salesAmountABSRankReport.vue')
                                  },
                                  {
                                      path: 'dashboardReport',
                                      title: '数据看板',
                                      name: 'dashboardReport',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/dataReport/dashboardReport/dashboard.vue')
                                  },
                                  {
                                      path: 'salesReportSetting',
                                      title: '报表设置',
                                      name: 'salesReportSetting',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/dataReport/setting/salesReportSetting.vue')
                                  }
                              ]
                          },
                          {
                              path: '/marketData',
                              name: 'marketData',
                              title: '市场数据',
                              component: Main,
                              children: [
                                  {
                                      path: 'cPASaleData',
                                      title: 'CPA数据',
                                      name: 'cPASaleData',
                                      meta: {
                                          requireAuth: true
                                      },
                                      icon: 'compose',
                                      component: () => import('@/views/marketData/cPASaleData/cPASaleDataQuery.vue')
                                  }
                              ]
                          }
]
export const routers = [
    loginRouter,
    ...appRouter,
    page403,
    page404,
    page500,
    loginJump
]



// WEBPACK FOOTER //
// ./src/router/router.js